export default __webpack_public_path__ + "static/media/fsiRealCase2-mobile-sc.f74dc00d.jpg";